import { RefObject, useEffect } from 'react';

type Params = {
  contentRef: RefObject<HTMLDivElement>;
  targetRef: RefObject<HTMLElement>;
  handler: () => void;
  isOpen: boolean;
  isDisabled: boolean;
};

export default function useOnClickOutside({
  contentRef,
  targetRef,
  handler,
  isOpen,
  isDisabled,
}: Params) {
  useEffect(() => {
    if (isDisabled) {
      return;
    }

    const listener = (event: Event) => {
      if (
        !contentRef.current ||
        !targetRef.current ||
        contentRef.current.contains(event.target as Node) ||
        targetRef.current.contains(event.target as Node)
      ) {
        return;
      }

      handler();
    };

    if (isOpen) {
      document.addEventListener('click', listener);
    }

    return () => {
      document.removeEventListener('click', listener);
    };
  }, [contentRef, targetRef, handler, isOpen, isDisabled]);
}
